import { IBankInitialState } from "../../../types/master/bankInterface";
import { BankActionTypes, BankActions } from "../../actionTypes/master/bankActionTypes";

const initialState: IBankInitialState = {
  bankList: [],
  bankData: {
    id: 0,
    bank_name_id: 0,
    account_number: "",
    ifsc_code: "",
    branch_location: "",
    contact_name: "",
    branch_contact: "",
    branch_landline: "",
    created_by: 0,
    createdAt: "",
    updatedAt: "",
    banklistid: "",
    banklist: {
      id: 0,
      bank_name: "",
    },
  },
  bankListPageCount: 0,
};

export default function bankReducer(state = initialState, action: BankActionTypes): IBankInitialState {
  switch (action.type) {
    case BankActions.SET_BANK_LIST:
      return {
        ...state,
        bankList: action.payload,
      };

    case BankActions.SET_BANK_LIST_PAGE_COUNT:
      return {
        ...state,
        bankListPageCount: action.payload,
      };

    case BankActions.SET_BANK_DATA_BY_ID:
      return {
        ...state,
        bankData: action.payload,
      };

    default:
      return state;
  }
}
